var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logobox"},[_c('img',{class:['logo', {logoMedia:_vm.dev}],attrs:{"src":require('@/assets/img/logo.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }